import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Radio, Typography } from "@mui/material";

import useShopContext from "@hooks/useShopContext";
import { updateResponses } from "@common/utils/questionUtils";
import { prefixCurrency } from "@common/utils/currency";

const PREFIX = "SelectOption";

const classes = {
  option: `${PREFIX}-option`,
  radioButton: `${PREFIX}-radioButton`,
  checkedRadioButton: `${PREFIX}-checkedRadioButton`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
  gap: theme.spacing(0.5),
  display: "flex",
  alignItems: "center",
  borderRadius: "5px",
  justifyContent: "flex-start",
  backgroundColor: "#FFF",
  border: theme.bordered ? `1px solid ${theme.palette.secondary.main}` : "none",
  boxShadow: theme.bordered ? "none" : theme.shadows[2],
  margin: "5px 0",
  "&:hover": {
    backgroundColor: theme.palette.grey[100],
    boxShadow: theme.bordered ? "none" : theme.shadows[3],
  },

  [`& .${classes.radioButton}`]: {
    color: theme.palette.accent.main,
  },

  [`& .${classes.checkedRadioButton}`]: {
    color: theme.palette.accent.main,
  },
}));

const SelectOption = ({ value, option, responses, setResponses, qnNum, onNext }) => {
  const { vendor } = useShopContext();

  const active = value.selected_options ? value.selected_options.text === option.text : false;

  const handleClick = () => {
    updateResponses(option, responses, setResponses, qnNum);
    setTimeout(() => onNext(), 200);
  };

  return (
    <StyledButton onClick={handleClick}>
      <Radio
        sx={{ p: 0 }}
        classes={{
          root: classes.radioButton,
          checked: classes.checkedRadioButton,
        }}
        checked={active}
        color="default"
      />
      <div style={{ flex: 1, textAlign: "left" }}>
        <Typography
          variant="body1"
          sx={{
            textTransform: "None",
            color: (theme) => theme.palette.common.black,
            lineHeight: 1.1,
          }}
        >
          {option.text}
        </Typography>
      </div>
      <div style={{ textAlign: "right" }}>
        <Typography variant="body1" sx={{ color: (theme) => theme.palette.success.main }}>
          {option.price && `+${prefixCurrency(option.price, vendor)}`}
        </Typography>
      </div>
    </StyledButton>
  );
};

export default SelectOption;
